import { loadConfig, type AppConfig } from './config';
import { IdbBackend } from './idb';
import { PbSession } from './pb-auth';
import { PocketBaseBackend } from './pocketbase';
import { hydrate, initStorage } from '../db';

export { SCHEMA_VERSION, SchemaVersionMismatchError } from './pocketbase';
export type { AppConfig } from './config';

let session: PbSession | null = null;

/** The PocketBase session, or null in local mode. */
export function currentSession(): PbSession | null {
  return session;
}

/**
 * Pick the backend from config.json, make sure the user is signed in when the
 * backend needs it, and load their progress into memory.
 *
 * `authenticate` is handed the session when there is no valid stored token; it
 * should resolve once sign-in succeeded (the app layer supplies the screen, so
 * core stays UI-free).
 */
export async function setupStorage(
  authenticate: (session: PbSession) => Promise<void>,
): Promise<AppConfig> {
  const cfg = await loadConfig();

  if (cfg.backend === 'pocketbase') {
    session = new PbSession(cfg.pocketbaseUrl);
    if (!(await session.tryRefresh())) await authenticate(session);
    initStorage(new PocketBaseBackend(session));
  } else {
    session = null;
    initStorage(new IdbBackend());
  }

  await hydrate();
  return cfg;
}

/** Drop the stored token and restart the app at the sign-in screen. */
export function signOut(): void {
  session?.signOut();
  location.reload();
}
